import { inject, Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { Worklist, WorklistLight } from "../../models/worklist";
import { environment } from "../../../../../../../environments/environment";

@Injectable()
export class WorklistBackend {
  private readonly http = inject(HttpClient);

  loadById(worklistId: string): Observable<Worklist> {
    return this.http.get<Worklist>(
      `${environment.snoots.api.diagnostic}/worklists/${worklistId}`
    );
  }

  loadByIdLight(worklistId: string): Observable<WorklistLight> {
    return this.http.get<Worklist>(
      `${environment.snoots.api.diagnostic}/worklists/${worklistId}`
    );
  }
}
